import React, { type ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports -- Retains the existing writers' control path during migration.
import { Subscribe } from 'unstated';

import { expValEquals } from '@confluence/feature-experiments';

import { BannerStateContainer } from './BannerStateContainer.ts';
import { useBannerActions, type BannerActions } from './useBannerState.ts';

type BannerActionsProviderProps = {
	children: (actions: BannerActions) => ReactNode;
};

const BANNER_CONTAINERS = [BannerStateContainer];

const BannerActionsProviderWithHooks = ({ children }: BannerActionsProviderProps) => {
	const actions = useBannerActions();
	return <>{children(actions)}</>;
};

/** Migration boundary for write-only consumers. Treatment does not subscribe to banner updates. */
export const BannerActionsProvider = ({
	children,
}: BannerActionsProviderProps): React.JSX.Element => {
	if (expValEquals('confluence_banner_store_migration', 'isEnabled', true)) {
		return <BannerActionsProviderWithHooks>{children}</BannerActionsProviderWithHooks>;
	}

	return (
		<Subscribe to={BANNER_CONTAINERS}>
			{(state: BannerStateContainer) => <>{children(state)}</>}
		</Subscribe>
	);
};
